import React from 'react';
import {Provider} from 'react-redux';
import {BrowserRouter as Router} from 'react-router-dom';
import Layout from './components/Layout';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'semantic-ui-css/semantic.min.css';
import './sass/styles.css';
import store from './store/store';

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Layout />
      </Router>
    </Provider>
  );
}

export default App;